export enum PossibleDigitalModulesType {
  EXPERIENCE = 'EXPERIENCE',
  WEBSITE_LINK = 'WEBSITE_LINK',
  CUSTOM_CONTENT = 'CUSTOM_CONTENT',
  EXPERIENCE_INDEX = 'EXPERIENCE_INDEX',
  SERIAL_NUMBER_ROUTER = 'SERIAL_NUMBER_ROUTER',
}

export type ProductSearchResultsType = {
  id: string;
  image: string;
  name: string;
  slug: string;
};

export type DigitalModuleInfoType = {
  type: string;
  moduleData:
    | ExperienceModuleData
    | WebsiteModuleData
    | ExperienceIndexModuleData
    | CustomModuleData
    | SerialNumberRouterModuleData;
};

export interface DigitalModuleData {
  text: string;
  backgroundColor: string;
  color: string;
}

export interface ExperienceModuleData extends DigitalModuleData {
  productId: string;
  slug: string;
  image: string;
  hideImage: boolean;
  name: string;
}

export interface WebsiteModuleData extends DigitalModuleData {
  linkURL: string;
  image: string | null;
}

export interface ExperienceIndexModuleData
  extends Omit<DigitalModuleData, 'text'> {
  productIds: string[];
  allSelected: boolean;
  productArray: ProductSearchResultsType[];
}

export interface CustomModuleData extends DigitalModuleData {
  customContent: string;
  showBackground: boolean;
}

export interface SerialNumberRouterModuleData {
  backgroundColor: string;
  color: string;
  hideImage: boolean;
  image: string;
  text: string;
  failureMessage?: string;
  inputLabel?: string;
}
